/* eslint-disable */
import Swiper, { Pagination } from 'swiper';
Swiper.use(Pagination);

export default {
  init() {
    let plansSwiper;

    function checkWidth(x) {
      if (x.matches) {
        plansSwiper = new Swiper('.plans-container', {
          spaceBetween: 20,
          autoHeight: true,
          pagination: {
            el: '.plans__pagination',
            clickable: true
          },
          on: {
            slideChange: function() {
              const nextEl = this.slides[this.activeIndex + 1];
              if (nextEl) {
                const { height } = nextEl.children[0].getBoundingClientRect();
                this.slides[this.activeIndex].style.height = `${height}px`;
                this.updateAutoHeight(300);
              }
            },
            init: function() {
              const nextEl = this.slides[this.activeIndex + 1];
              if (nextEl) {
                setTimeout(() => {
                  const { height } = nextEl.children[0].getBoundingClientRect();
                  this.slides[this.activeIndex].style.height = `${height}px`;
                  this.updateAutoHeight(0);
                }, 0);
              }
            }
          }
        });
      } else {
        if (plansSwiper) {
          plansSwiper.destroy();
        }
      }
    }

    var x = window.matchMedia('(max-width: 767px)');
    checkWidth(x);
    x.addListener(checkWidth);
  }
};
